import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useStore } from 'react-redux';
import { changePartLength } from '../../redux/actions/parts';
import { DECREMENT_NO_OF_FABRIC_UNITS, INCREMENT_NO_OF_FABRIC_UNITS, UPDATE_DISPLAY_UNITS } from '../../redux/reducers/settings';
import { DebouncedInput } from '../DebouncedInput';
import "./styles.scss";
import alertify from "../../libs/alert"

export type OrderQuantityProps = {
    currentPartLength: number
    maxLength: number
    stepSize: number
    onOrderChanged: (value:any) => void
    setTypingInProgress: (inProgress:boolean)=>void
}

export const OrderQuantity = (props: OrderQuantityProps) => {
    const { maxLength, stepSize, currentPartLength, onOrderChanged, setTypingInProgress } = props
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [validationErrorMessage, setValidationErrorMessage] = useState('');

    const displayError = useCallback(() => {
        validationErrorMessage && alertify.alert(t("editor.alert_warning_title1"), validationErrorMessage, t("i18n.ok"),
            () => { }).set('modal', true)
    }, [validationErrorMessage])

    const validateInput = useCallback((value) => {
        value = value || 0;
        const isValueTooBig = (value > maxLength);
        const isValueTooSmall = (value < 0.2);
        if (isValueTooBig) {
            setValidationErrorMessage(`${t("editor.fabric_exceeds_max_length")}: ${maxLength} m.`)
        } else if (isValueTooSmall) {
            setValidationErrorMessage('')
        }
        return !isValueTooBig && !isValueTooSmall
    }, [maxLength])

    return <div className="orderLength">
        <div className="orderLengthLabel">{t("editor.custom.toolPanel_orderQuantity_label")}</div>
        <div className="orderLengthControl">
            <DebouncedInput useCeiling 
                step={stepSize} 
                setTypingInProgress={setTypingInProgress}
                currentValue={currentPartLength}
                onValueChanged={(value)=>{onOrderChanged(value)}} 
                className="FinputNumber" />
        </div>
    </div>
}